<template>
    <div>
    <a v-html="buttonTxt" v-if="this.cart_qty==0"
            href="#"
            @click="addItem"
            :class="css_classLocal"
            :title="titleLocal"
            data-initial-text="Купить"><slot></slot>
    </a>
        <a v-else
            href="/cart"
           class="btn btn--green card4__btn"
           >
            В корзине
        </a>
    </div>
</template>

<script>
    export default {
        name: "cart-add-button",
        props: {
            product_id : Number,
            price : String,
            title : String,
            css_class: {
                type : String,
                default: 'btn btn--red card4__btn'
            }
        },
        data () {
            return {
                productIdLocal: this.product_id,
                priceLocal: this.price,
                titleLocal: this.title,
                css_classLocal: this.css_class,
                loading: false
            }
        },
        computed: {
            cart_qty () {
                const cart_items = this.$store.getters.cartitems;
                let product = cart_items.filter((item) => {
                    return item.product_id==this.productIdLocal;
                });

                if(typeof product[0] !== 'undefined') {
                    return product[0].qty;
                }
                return 0;
            },
            buttonTxt() {
                if(this.$store.getters.loading && this.loading) {
                    return '<i class="fa fa-spinner fa-spin fa-1x fa-fw"></i>';
                } else {
                    return 'Купить';
                }
            }
        },
        methods: {
            addItem(event) {
                this.loading = true;
                event.preventDefault();
                this.$store.dispatch(
                    'addProduct',
                    {
                        product_id: this.productIdLocal,
                        qty: 1,
                        variant_id: 0
                    })
            }
        }
    }
</script>

<style scoped>

</style>